import 'babel-polyfill'

import Vue from 'vue'
import Vuetify from 'vuetify'
import es from 'vuetify/es5/locale/es'

import Notifications from 'vue-notification'
import velocity from 'velocity-animate'
import InstantSearch from 'vue-instantsearch'
import VeeValidate from 'vee-validate'
import veeLangEs from 'vee-validate/dist/locale/es'

import VueQuillEditor from 'vue-quill-editor'

//  global components
import GlobalComponents from './globalComponents'

//  app.vue
import App from './App'

//  router
import router from './router'

//  store
import { store } from './store/store'
import mixinPermisos from './mixins/permisos'

import './assets/vuelyCss'

import VueTheMask from 'vue-the-mask'

import masker from 'vue-the-mask/src/masker.js'
import tokens from 'vue-the-mask/src/tokens'

import money from 'v-money'

import VueCurrencyInput from 'vue-currency-input'
import VueCurrencyFilter from 'vue-currency-filter'

import { formatoFecha, nombreCentro, strNbr, nbrStr } from '@/helpers/filtros'
import VueYoutube from 'vue-youtube'
import VueMce from 'vue-mce'

window.Vue = require('vue')

Vue.use(VueYoutube)
Vue.use(VueQuillEditor)
Vue.mixin(mixinPermisos)
Vue.use(VueMce)
//  plugins
Vue.use(Vuetify, {
  lang: {
    locales: { es },
    current: 'es'
  },
  theme: store.getters.selectedTheme.theme
})

Vue.use(InstantSearch)
// Vue.use(VueBreadcrumbs)
Vue.use(Notifications, { velocity })
Vue.use(GlobalComponents)

veeLangEs.messages.required = () => 'El campo es obligatorio.'

Vue.use(VeeValidate, {
  locale: 'es',
  dictionary: {
    es: veeLangEs
  },
  inject: false
})

Vue.use(VueTheMask)
Vue.use(money, { precision: 2, decimal: ',', thousands: '.' })

Vue.filter('mask', (value, mask) => masker(value, mask, true, tokens))

Vue.use(VueCurrencyInput, {
  globalOptions: { currency: { prefix: false } }
})

Vue.use(VueCurrencyFilter,
  {
    symbol: '$',
    thousandsSeparator: '.',
    fractionCount: 2,
    fractionSeparator: ',',
    symbolPosition: 'front',
    symbolSpacing: true
  })

Vue.filter('formatoFecha', formatoFecha)
Vue.filter('nombreCentro', nombreCentro)
Vue.filter('strNbr', strNbr)
Vue.filter('nbrStr', nbrStr)

const ignoreWarnMessage = 'The .native modifier for v-on is only valid on components but it was used on <div>.'
Vue.config.warnHandler = function (msg, vm, trace) {
  // `trace` is the component hierarchy trace
  if (msg === ignoreWarnMessage) {
    msg = null
    vm = null
    trace = null
  }
}

/* eslint-disable no-new */
new Vue({
  store,
  router,
  render: h => h(App),
  components: { App }
}).$mount('#app')
